import { render, staticRenderFns } from "./RightItem.vue?vue&type=template&id=231d76e0&scoped=true&"
import script from "./RightItem.vue?vue&type=script&lang=ts&"
export * from "./RightItem.vue?vue&type=script&lang=ts&"
import style0 from "./RightItem.vue?vue&type=style&index=0&id=231d76e0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "231d76e0",
  null
  
)

export default component.exports